angular.module('qkr').controller('OptionSetEditController', ($scope, $rootScope, $uibModalInstance, optionSet,
                                                             optionSetAction, optionSetList, merchantService,
                                                             inventoryService, FormHelper, utils, gettextCatalog,
                                                             appConfig, _, $log) => {
    $scope.optionSetAction = optionSetAction;
    $scope.showOptionType = false;
    $scope.errors = {};
    $scope.allowEditOnOutletLevel = merchantService.behaviour(merchantService.merchantInfo,
        'optionSetPage.allowEditOnOutletLevel');
    $scope.isCharityOptionSet = merchantService.behaviour(merchantService.merchantInfo,
        'optionSetPage.charityOptionSet');
    $scope.isEditable = ((appConfig.isElevatedUser && !appConfig.outletLevel) || $scope.allowEditOnOutletLevel)
        && merchantService.behaviour($rootScope.merchantInfo, 'optionSetPage.allowEdit');

    // Function to initialize a newOption
    const setNewOption = function() {
        $scope.newOption = {paymentAdjust: 0, selectedByDefault: false};
    };

    const MAX_OPTIONS_IN_SET = 3;

    setNewOption();  // Initialize new option

    // Option Set types for display in dropdown
    $scope.optionSetTypes = [
        {type: 'list1', display: gettextCatalog.getString('Single Option Only')},
        {type: 'listN', display: gettextCatalog.getString('Multiple Options')}
    ];

    // Check the action the user is doing "create", "update" or "clone"
    switch (optionSetAction) {
        case 'create': {
            $scope.newOptionSet = {
                type: 'bool',
                options: []
            };
            break;
        }

        case 'edit': {
            $scope.showOptionType = true;
            $scope.newOptionSet = optionSet;
            break;
        }

        case 'clone': {
            $scope.showOptionType = true;
            $scope.newOptionSet = optionSet;
            $scope.newOptionSet.name = '';   // Set name to empty as this is a
            // New option set

            // Set Ids to null so we dont overwrite
            $scope.newOptionSet.id = null;
            $scope.newOptionSet.options.map(option => option.id = null);

            break;
        }
    }

    const getNumValidOptions = function(optionSet) {
        return optionSet.options.filter(o => !o.hidden).length;
    };

    $scope.validateOptionSetSize = function() {
        return $scope.isCharityOptionSet && getNumValidOptions($scope.newOptionSet) > MAX_OPTIONS_IN_SET - 1;
    };

    $scope.maxOptionsReached = $scope.validateOptionSetSize();

    $scope.save = function(inValid) {
        $scope.formSubmitted = true;

        // If there is a partially added option - i.e. user didn't press the
        // Plus button, then add it
        if ($scope.newOption.name) {
            if ($scope.addOption() === false) {
                return;
            }
        }

        if ((inValid && !$scope.validateForm()) || inValid  || !$scope.validateForm()) {
            return;
        }

        /*
         * Check the type, if type is "amount" and the options list contains
         * more than 1 option, i.e. additional options other than the single
         * custom amount option then the type should be "listC1"
         */
        if ($scope.newOptionSet.type === 'amount' && $scope.newOptionSet.options.length > 1) {
            $scope.newOptionSet.type = 'list1C';
        }

        $scope.saving = true;

        // Form request to send to server
        const request = angular.copy($scope.newOptionSet);

        if (optionSetAction === 'edit') {
            inventoryService.updateOptionSet(request)
                .then((promise) => {
                        $uibModalInstance.close(promise);
                    },
                    (promise) => {
                        new FormHelper($scope).handleResponse(promise);
                    })
                .finally(() => {
                    $scope.saving = false;
                })
                .catch($log.error);
        } else {
            inventoryService.saveOptionSet(request)
                .then((promise) => {
                        // Reload the dashboard info
                        $rootScope.$broadcast('reloadDashboard');

                        $uibModalInstance.close(promise);
                    },
                    (promise) => {
                        new FormHelper($scope).handleResponse(promise);
                    })
                .finally(() => {
                    $scope.saving = false;
                })
                .catch($log.error);
        }
    };

    $scope.validateForm = function() {
        // Empty the errors list
        $scope.errors = {};
        let valid = true;
        const errors = {};


        const existingOptionSetWithSameName = optionSetList.filter(option => {
            return option.name === $scope.newOptionSet.name && option.id !== $scope.newOptionSet.id;
        });

        if (existingOptionSetWithSameName.length > 0) {
            errors.name = gettextCatalog.getString('Option set reference name must be unique');
            valid = false;
        }

        // Check at least 1 option is created
        if ($scope.newOptionSet.options.length <= 0) {
            errors.noOptions = gettextCatalog.getString('Please provide option set details');
            valid = false;
        }

        // Find the number of "By Default" turned on
        const defaultCount = $scope.newOptionSet.options.filter(option => option.selectedByDefault).length;

        // Check number of "By Default" selected is only 1 if type is not
        // "listN"
        if ($scope.newOptionSet.type !== 'listN' && $scope.newOptionSet.type !== 'amount'
            && $scope.newOptionSet.type !== 'list1C') {
            if (defaultCount < 1) {
                errors.maxDefaultsSelected =
                    gettextCatalog.getString('Select which option is the default using the ON/OFF toggle button');
                valid = false;
            }
        }

        if ($scope.newOptionSet.type !== 'listN') {
            if (defaultCount > 1) {
                errors.maxDefaultsSelected = gettextCatalog.getString('Only 1 option should be selected by default');
                valid = false;
            }
        }

        // Validation for ListN
        if ($scope.newOptionSet.type === 'listN') {
            valid = validateListN(defaultCount, errors);
        }

        for (let i = 0; i < $scope.newOptionSet.options.length; i++) {
            if ($scope.newOptionSet.options[i].selectedByDefault && $scope.newOptionSet.options[i].hidden) {
                if (!$scope.newOptionSet.options[i].errors) {
                    $scope.newOptionSet.options[i].errors = {};
                }
                $scope.newOptionSet.options[i].errors.defaultInvisible =
                    gettextCatalog.getString('The default option cannot be invisible');
            }
            const er = $scope.newOptionSet.options[i].errors;
            if (!utils.isEmpty(er)) {
                valid = false;
                errors.options = gettextCatalog.getString('Option errors');
            }
        }

        $scope.errors = errors;

        return valid;
    };

    function validateListN(defaultCount, errors) {
        const hiddenCount = $scope.newOptionSet.options.filter(option => option.hidden).length;

        let valid = true;
        // TEMPORARY change - phone only supports a min of 0 so we
        // Explicitly se this here
        $scope.newOptionSet.minSelected = 0;

        // Check min value
        if (utils.hasNoValue($scope.newOptionSet.minSelected)) {
            errors.minSelected = gettextCatalog.getString('Please enter a minimum value');
            valid = false;
        } else {
            if ($scope.newOptionSet.minSelected < 0) {
                errors.minSelected = gettextCatalog.getString('Minimum value should be at least 0');
                valid = false;
            }

            if ($scope.newOptionSet.minSelected > $scope.newOptionSet.options.length) {
                errors.minSelected = gettextCatalog.getString('Minimum value exceeds the number of options');
                valid = false;
            }

            if ($scope.newOptionSet.minSelected > $scope.newOptionSet.maxSelected) {
                errors.minSelected = gettextCatalog.getString('Minimum value is greater than maximum value');
                valid = false;
            }

            // Check number of "By Default" selected is not less than Min
            // Value
            if (defaultCount < $scope.newOptionSet.minSelected) {
                errors.minDefaultsSelected = gettextCatalog.getString('At least') + ' '
                    + $scope.newOptionSet.minSelected + ' '
                    + gettextCatalog.getString('options should be selected by default');
                valid = false;
            }
        }

        // Check max value
        if (utils.hasNoValue($scope.newOptionSet.maxSelected)) {
            errors.maxSelected = gettextCatalog.getString('Please provide a maximum selectable value');
            valid = false;
        } else {
            if ($scope.newOptionSet.maxSelected > getNumValidOptions($scope.newOptionSet)) {
                errors.maxSelected = gettextCatalog.getString('Maximum value exceeds the number ' +
                    'of visible options');
                valid = false;
            }

            if ($scope.newOptionSet.maxSelected > ($scope.newOptionSet.options.length - hiddenCount)) {
                errors.maxSelected = gettextCatalog.getString('Maximum value exceeds the ' +
                    'number of visible options');
                valid = false;
            }

            // Check number of "By Default" selected is not greater than MAx
            // Value
            if (defaultCount > $scope.newOptionSet.maxSelected) {
                errors.maxDefaultsSelected = gettextCatalog.getString('A maximum of') + ' '
                    + $scope.newOptionSet.maxSelected + ' '
                    + gettextCatalog.getString('options should be selected by default');
                valid = false;
            }
        }

        return valid;
    }

    // Close the modal
    $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.addOption = function() {
        if (!$scope.validateAddOption()) {
            return false;
        }

        $scope.newOptionSet.options.push($scope.newOption);
        $scope.createForm.newOptionName.$setPristine();
        $scope.createForm.newOptionName.$setUntouched();

        // Check if selected by default is on or off, this option will be the
        // Last in the array
        $scope.toggleSelectionDefaults($scope.newOptionSet.options.length - 1, $scope.newOption.selectedByDefault);

        // If not type boolean then create a new empty option
        if ($scope.newOptionSet.type != 'bool') {
            setNewOption();
        }

        // If form was already submitted then revalidate, user may have fixed
        // Some errors
        if ($scope.formSubmitted) {
            $scope.validateForm();
        }

        $scope.maxOptionsReached = $scope.validateOptionSetSize();
    };

    $scope.validateAddOption = function() {
        // Empty the errors list
        $scope.newOption.errors = null;
        let valid = true;
        const errors = {};

        if (utils.hasNoValue($scope.newOption.name)) {
            errors.name = gettextCatalog.getString('Please enter a name');
            valid = false;
        }
        // Check for duplicates
        else {
            for (let i = 0; i < $scope.newOptionSet.options.length; i++) {
                if ($scope.newOptionSet.options[i].name === $scope.newOption.name) {
                    errors.name = gettextCatalog.getString('Name must be unique');
                    valid = false;
                    break;
                }
            }
        }

        // Add to errors so footer error displays
        delete ($scope.errors.options);

        if (valid === false) {
            $scope.errors.options = gettextCatalog.getString('Option errors');
        }

        $scope.newOption.errors = errors;

        return valid;
    };

    $scope.validateExistingOption = function(optionToTest, index) {
        // Empty the errors list
        optionToTest.errors = null;
        let valid = true;
        const errors = {};

        if (utils.hasNoValue(optionToTest.name)) {
            errors.name = gettextCatalog.getString('Please enter a name');
            valid = false;
        }
        // Check for duplicates
        else {
            for (let i = 0; i < $scope.newOptionSet.options.length; i++) {
                if (($scope.newOptionSet.options[i].name === optionToTest.name) && (i != index)) {
                    errors.name = gettextCatalog.getString('Name must be unique');
                    valid = false;
                    break;
                }
            }
        }

        optionToTest.errors = errors;

        // Clear the errors.option property if necessary - to remove the footer
        // Error
        delete ($scope.errors.options);

        for (let i = 0; i < $scope.newOptionSet.options.length; i++) {
            const er = $scope.newOptionSet.options[i].errors;
            if (!utils.isEmpty(er)) {
                $scope.errors.options = gettextCatalog.getString('Option errors');
            }
        }

        return valid;
    };

    $scope.removeOption = function(index) {
        $scope.newOptionSet.options.splice(index, 1);
        $scope.maxOptionsReached = $scope.validateOptionSetSize();
    };

    $scope.changeVisibility = function(option, invisible, index) {
        option.hidden = invisible;
        $scope.errors = {};
        option.errors = {};
        if (option.selectedByDefault && invisible) {
            option.errors.defaultInvisible = gettextCatalog.getString('The default option cannot be invisible');
        }
        $scope.validateExistingOption(option, index);
    };

    $scope.setupYesNo = function() {
        $scope.showOptionType = true;

        if (optionSetAction === 'create') {
            $scope.newOptionSet = {
                type: 'bool',
                options: [
                    {hidden: false, name: 'Yes', selectedByDefault: false, paymentAdjust: 0},
                    {hidden: false, name: 'No', selectedByDefault: true, paymentAdjust: 0}
                ]
            };
        }
    };

    /*
     * This makes the checkbox behave like a radio button for the Yes / No
     * selection If option is changed then the other option it set to that value
     * e.g. if "Yes" is changed from "selectedByDefault" true to
     * "selectedByDefault" false then "No" gets set as "selectedByDefault" true
     * e.g. if "Yes" is changed from "selectedByDefault" false to
     * "selectedByDefault" true then "No" gets set as "selectedByDefault" false
     */
    $scope.toggleYesNoDefaults = function(index, selected) {
        if (selected) {
            for (let i = 0; i < $scope.newOptionSet.options.length; i++) {
                if (i !== index) {
                    $scope.newOptionSet.options[i].selectedByDefault = !selected;
                }
            }
        }
    };

    $scope.setupSelection = function() {
        $scope.showOptionType = true;

        if (optionSetAction === 'create') {
            $scope.newOptionSet = {
                type: 'list1',
                options: []
            };
        }
    };

    $scope.setupSelectionCustom = function() {
        $scope.showOptionType = true;

        if (optionSetAction === 'create') {
            $scope.newOptionSet = {
                type: 'amount',
                options: [
                    {hidden: false, name: 'Enter Amount', selectedByDefault: false, isCustomOption: true}
                ]
            };
        }
    };

    $scope.toggleSelectionDefaults = function(index, selected) {
        if ($scope.newOptionSet.maxSelected > 1 && $scope.newOptionSet.type === 'listN') {
            if (!selected) {
                $scope.newOptionSet.options[index].selectedByDefault = selected;
                $scope.newOptionSet.options[index].errors = {};
            }
        } else if (selected) {
            $scope.newOptionSet.options = $scope.newOptionSet.options.map((option, i) => {
                if(i !== index) {
                    option.selectedByDefault = !selected;
                    option.errors = {};
                }

                return option;
            });
        }
    };

    $scope.sortOptions = {
        stop(e, ui) {
            // Loop over and set the pos to current index
            $scope.newOptionSet.map((option, index) => {
                option.pos = index;
                return option;
            });
        },
        axis: 'y',
        handle: '.sorthandle'
    };

    $scope.back = function() {
        $scope.createForm.$setPristine();
        $scope.createForm.$setUntouched();
        $scope.showOptionType = false;
        $scope.errors = {};
        $scope.newOption.errors = null;
    };
});



// WEBPACK FOOTER //
// ./src/controllers/optionsetedit.controller.js